import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import defaultTheme from "../../theme/default";
import { MessagingLayer } from "../../context/messaging-layer";
import { ToastNotifications } from "../../context/toast-notifications";
import { RootContext } from "../../context/root-ref";
import { constants } from "../../resource/constants";
import { addToast, removeToast } from "../../redux/actions";
import PriceProcedures from "./price-procedures";

class PriceProceduresWrapper extends Component {
  constructor(props) {
    super(props);
    this.rootRef = React.createRef();
  }

  componentWillUnmount() {
    const abortController = window[constants.abortControllerKey];
    if (abortController) {
      abortController.abort();
    }
  }

  render() {
    const {
      toasts,
      addToast,
      removeToast,
      screenParams,
      theme = {},
      extendedConfiguration: { priceProcedures }
    } = this.props;

    const components = { ...defaultTheme, ...theme };

    return (
      <MessagingLayer
        components={components}
        globalDialogConfig={screenParams.dialogConfig}
        formRef={this.rootRef}
      >
        <ToastNotifications components={components}>
          <RootContext.Provider value={this.rootRef}>
            <form id='containerForm' ref={this.rootRef}>
              <PriceProcedures
                components={components}
                config={priceProcedures}
                toasts={toasts}
                addToast={addToast}
                removeToast={removeToast}
              />
            </form>
          </RootContext.Provider>
        </ToastNotifications>
      </MessagingLayer>
    );
  }
}

PriceProceduresWrapper.propTypes = {
  addToast: PropTypes.func.isRequired,
  removeToast: PropTypes.func.isRequired,
  fieldConfigurations: PropTypes.object,
  toasts: PropTypes.array,
  theme: PropTypes.object
};

export default connect(
  ({ tdFlow }) => ({
    toasts: tdFlow.toasts,
    screenParams: tdFlow.screenParams
  }),
  {
    addToast,
    removeToast
  }
)(PriceProceduresWrapper);
